import Backdrop from '@mui/material/Backdrop';
import React from 'react';
import CustomCircularProgress from '@ui-components/Progress/CustomCircularProgress';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import Box from '@mui/material/Box';

interface LoaderComponentProps {
  isOpen: boolean;
  textForLoader?: string;
}
const LoaderComponent: React.FC<LoaderComponentProps> = ({
  isOpen,
  textForLoader,
}) => {
  return (
    <Backdrop open={isOpen} sx={{ zIndex: 1300 }}>
      <Box className="flex flex-direction-column flex-justify-center align-items-center">
        <CustomCircularProgress id="circular-progress" color="primary" />
        {textForLoader && (
          <CustomTypography
            id="loader-text"
            variant="subtitle2"
            align="center"
            className="pt-12"
            color="primary"
          >
            {textForLoader}
          </CustomTypography>
        )}
      </Box>
    </Backdrop>
  );
};

export default LoaderComponent;
